{
    "ModalTitleStatusChange": "ACD Agent Sign In",
    "LocationStatusTitle": "Location",
    "LocationStatusDescription": "Choose a device and ACD agent to sign in.",
    "StatusOptionsTitle": "Options",
    "AcdGroupOptionsDescription": "If the target telephone server supports it, you can choose the ACD group that the selected ACD status will be specifically changed for.",
    "AcdGroupLabel": "ACD Group",
    "AcdAgentLabel": "ACD Agent",
    "FooterButtonOk": "OK",
    "FooterButtonCancel": "Cancel",
    "FooterButtonHelp": "Help",
    "NAME": "StatusChange",
    "StatusChange_PromptMessage": "All configurations will be lost on close. Are you sure you want to close this window?",
    "StatusChange_PromptConfirm": "Yes",
    "StatusChange_PromptCancel": "Cancel",
    "StatusChange_DevicesLabel": "Device"
}